export default {
      id: "building-with-tree-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.e22fd14f.svg#building-with-tree",
      toString: function () {
        return this.url;
      }
    }